<template>
  <div class="_sidebar__toggle" @click="onSidebarToggle">
    <div class="_sidebar__toggle__indicator">
      <md-icon class="_sidebar__toggle__indicator__icon" v-if="!isSidebarOpen">arrow_left</md-icon>
      <md-icon class="_sidebar__toggle__indicator__icon" v-if="isSidebarOpen">arrow_right</md-icon>
    </div>
    <portal-target name="sidepanel-portal-toggle-bar-info" />
  </div>
</template>

<script>
export default {
  name: 'sidepanel-toggle-bar',
  props: {
    isSidebarOpen: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    onSidebarOpen() {
      document.body.classList.add('_sidebarIsOn');
      this.$emit('update:isSidebarOpen', true)
    },
    onSidebarClose() {
      document.body.classList.remove('_sidebarIsOn');
      this.$emit('update:isSidebarOpen', false)
    },
    onSidebarToggle() {
      if (this.isSidebarOpen) {
        this.onSidebarClose();
      } else {
        this.onSidebarOpen();
      }
    },
  },
  beforeDestroy() {
    this.onSidebarClose();
  },
  watch: {
    'isSidebarOpen': {
      immediate: true,
      handler: function() {
        if (this.isSidebarOpen) {
          return this.onSidebarOpen();
        }
        return this.onSidebarClose();
      }
    }
  }
}
</script>

<style lang="scss">
// 
</style>
